import {
  OnboardingSavePublicTransportDto,
  OnboardingSaveHighwaysDto,
  OnboardingSaveParkingDto,
} from '@interfaces/models';

export const formatParkingConfiguration = (
  parkingConfiguration?: OnboardingSaveParkingDto | null,
): OnboardingSaveParkingDto | undefined => {
  return parkingConfiguration
    ? {
        ...parkingConfiguration,
        ...(parkingConfiguration.unlimitedTime && {
          timeTo: undefined,
          timeFrom: undefined,
        }),
      }
    : undefined;
};

export const formatHighwaysConfiguration = (
  highwaysConfiguration?: OnboardingSaveHighwaysDto | null,
): OnboardingSaveHighwaysDto | undefined => {
  return highwaysConfiguration || undefined;
};

export const formatPublicTransportConfiguration = (
  publicTransportConfiguration?: OnboardingSavePublicTransportDto | null,
): OnboardingSavePublicTransportDto | undefined => {
  return publicTransportConfiguration
    ? {
        ...publicTransportConfiguration,
        ...(publicTransportConfiguration.unlimitedTime && {
          timeTo: undefined,
          timeFrom: undefined,
        }),
      }
    : undefined;
};
